const DOMAINS = {
    AB_TEST_LOG: 'https://co.naver.com',
    CAMPAIGN: 'https://m-campaign.naver.com',
    CARD: 'https://dbill.naver.com', // 카드 BE domain
    CARD_PAY: 'https://card.pay.naver.com', // 카드관리페이지 FE(내자산) domain
    CART: 'https://m.shopping.naver.com',
    DANAL_PG: 'https://ui.teledit.com',
    DICON: 'https://dcon.pay.naver.com',
    EVENT: 'https://event2.pay.naver.com',
    FOR_YOU: 'https://shopping.naver.com',
    GIFT: 'https://m.gift.naver.com',
    HELP: 'https://m.help.naver.com',
    HELP_PC: 'https://help.naver.com',
    INFLOW: 'https://inflow.pay.naver.com',
    L_PAY: 'https://nsp.pay.naver.com',
    M_HELP: 'https://m.help.pay.naver.com',
    M_SHOPPING: 'https://m.shopping.naver.com',
    MOBILIANS_PG: 'https://mup.mobilians.co.kr',
    NAVER_PC: 'https://www.naver.com',
    NAVER: 'https://m.naver.com',
    NAVER_BLOG_M: 'https://m.blog.naver.com',
    NAVER_TALK: 'https://ntalk.naver.com',
    NAVER_TALK_LIST: 'https://talks.naver.com',
    PAY: 'https://pay.naver.com',
    NID: 'https://nid.naver.com', // '리얼'환경만 제공 (alpha, dev, beta x)
    NPAY_BIZ: 'https://alpha-biz.pay.naver.com', // 아직 개발환경만 제공
    ORDERS: 'https://orders.pay.naver.com',
    PAY_M: 'https://m.pay.naver.com',
    PAYMONEY_API: 'https://paymoney-api.pay.naver.com',
    PC_HELP: 'https://help.pay.naver.com',
    PC_ORDER: 'https://order.pay.naver.com',
    // dev 버전을 보는 경로 PC_ORDER 과 같음
    ORDER_DEV: 'https://order.pay.naver.com',
    PC_PAY: 'https://pay.naver.com',
    PC_MARKETING: 'https://mkt.naver.com',
    SHOPPING_LIVE: 'https://im.pstatic.net',
    SHOPPING: 'https://shopping.naver.com',
    TALK_TALK: 'https://talk.naver.com',
    BOOKING_API: 'https://api.booking.naver.com',
    BOOKING: 'https://m.booking.naver.com',
    BOOKING_DEV: 'https://booking.naver.com',
    SHOPPING_CR: 'https://cr3.shopping.naver.com',
    CUSTOMS: 'https://unipass.customs.go.kr',
    FOREIGN_SETTING: 'https://foreign.pay.naver.com',
    FLEA_MARKET: 'https://fleamarket.naver.com',
    INVOICE: 'https://invoice.naver.com',
} as const

export default DOMAINS
